export default __webpack_public_path__ + "static/media/clean.cc6dd808.svg";